import React from 'react';
import { Form as UnformForm } from '@unform/web';
import { FormHandles, SubmitHandler } from '@unform/core';
import { FormHTMLAttributes } from 'react';

// Get the original props from the component, omitting the problematic ones
type UnformFormOriginalProps = Omit<React.ComponentProps<typeof UnformForm>, 'ref' | 'placeholder' | 'onPointerEnterCapture' | 'onPointerLeaveCapture'>;

// Create a new props interface that includes children and explicitly makes the problematic props optional
interface FormProps extends UnformFormOriginalProps {
  children: React.ReactNode;
  placeholder?: string;
  onPointerEnterCapture?: React.PointerEventHandler<HTMLFormElement>;
  onPointerLeaveCapture?: React.PointerEventHandler<HTMLFormElement>;
}

// Create the new component, forwarding the ref
export const Form = React.forwardRef<FormHandles, FormProps>(
  ({ children, ...rest }, ref) => {
    return (
      //Using 'any' as a temporary measure if types still conflict
      <UnformForm ref={ref} {...rest as any}>  
        {children}
      </UnformForm>
    );
  }
);
